import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const CST_TIMEZONE = "America/Chicago";

/**
 * Converts a date/time string from the backend to the user's local timezone.
 * If the string already contains a timezone offset (e.g. "-06:00"), it is parsed directly.
 * Otherwise, it is interpreted as CST (America/Chicago).
 */
function convertCSTToLocal(dateString: string): dayjs.Dayjs {
	const hasOffset = /[+-]\d{2}:\d{2}$/.test(dateString) || dateString.endsWith("Z");
	if (hasOffset) {
		return dayjs(dateString).local();
	}
	return dayjs.tz(dateString, CST_TIMEZONE).local();
}

export default convertCSTToLocal;
